import { useEffect } from 'react';
import { CompareLayerWrapper } from '~/app/pages/configurator/components/compare-layer-wrapper';
import { DialogProps } from '~/app/pages/summary/dialogs/dialog-props';
import { appTrackingService } from '~/app/tracking/app-tracking-service';
import { LayerType } from '~/app/tracking/feld-m-types';
import { Dialog } from '~/components/dialog';
import { useCatalog, useConfigurator } from '~/graphql/hooks/use-configurator';
import { useConfiguredCarTechnicalDataLazyQuery } from '~/graphql/hooks/use-configured-car-queries';
import { DriveTrain } from '~/graphql/mapper';

export function TechnicalDataDialog({ open, onClose }: DialogProps) {
	const { trimlines } = useCatalog();
	const carConfig = useConfigurator();
	const driveTrain = trimlines?.flatMap((t) => t.driveTrains)?.find((d) => d.status.selected);
	const { fetchTechnicalData, data: technicalData, loading } = useConfiguredCarTechnicalDataLazyQuery();

	useEffect(() => {
		if (open) {
			appTrackingService.updateLayerComponent(LayerType.TechnicalDataLayer, 'open');
			appTrackingService.viewChangeEvent({
				eventName: `configurator - ${LayerType.TechnicalDataLayer}`,
				componentName: 'configurator-configuration-overview',
			});
		}
	}, [open]);

	useEffect(() => {
		open &&
			fetchTechnicalData({
				variables: {
					configuredCar: {
						...carConfig.carIdentifier,
					},
				},
			});
	}, [open]);

	const configuredCarTechData = technicalData?.configuredCar?.technicalDataV2;

	const drivetrainWithConfiguredTechData = {
		...driveTrain,
		__item: {
			...driveTrain?.__item,
			technicalDataV2: {
				...driveTrain?.techData,
				modelAttributes: configuredCarTechData?.modelAttributes,
				consumptionAndEmission: configuredCarTechData?.consumptionAndEmission,
				items: configuredCarTechData?.items,
			},
		},
	} as DriveTrain;

	return (
		<Dialog open={open} onCloseButtonClick={onClose}>
			{driveTrain && technicalData && drivetrainWithConfiguredTechData && open && !loading && (
				<CompareLayerWrapper
					key="technical-data-dialog-summary"
					selectedDriveTrain={drivetrainWithConfiguredTechData}
					open={open}
					setIsOpen={() => {}}
					config={{
						selectedTab: 'technicalData',
						isDisabled: true,
					}}
				/>
			)}
		</Dialog>
	);
}
